var React = require('react');

function IconWysiwyg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.333 3H5.667A2.666 2.666 0 0 0 3 5.667v18.666A2.666 2.666 0 0 0 5.667 27h18.666A2.675 2.675 0 0 0 27 24.333V5.667A2.666 2.666 0 0 0 24.333 3zm0 21.333H5.667v-16h18.666zM21.667 15H8.333v-2.667h13.334zm-5.333 5.333h-8v-2.666h8z","transform":"translate(-3 -3)"}));
}

IconWysiwyg.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconWysiwyg;

IconWysiwyg.default = IconWysiwyg;
